import { Component, Inject, Input, OnInit, TemplateRef, ViewChild, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router, NavigationEnd } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { Constant } from 'src/app/constant/constant';
import { BuilderService } from 'src/app/services/builder.service';
import { getPageSize } from '../utils/calsoft-validators';
import { ListColumn } from '../list/list-column.model';
import { CommonService } from 'src/app/services/common.service';
import { Clipboard } from '@angular/cdk/clipboard';
import { tags } from 'src/app/data/mock/apps/contacts/data';
import { E } from '@angular/cdk/keycodes';

@Component({
  selector: 'calsoft-search-builder',
  templateUrl: './search-builder.component.html',
  styleUrls: ['./search-builder.component.scss']
})
export class SearchBuilderComponent implements OnInit, OnDestroy {

  sanitizedUrl: string = '';


  url = '';



  read: any = false;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  paginationDetail = new BehaviorSubject(
    {
      length: 10,
      pageIndex: 0,
      pageSize: 10
    });
  public page: any = Constant.PAGE;
  public size: any = Constant.SIZE;
  sortParam: any = 'builderId' + "," + Constant.Dsc;

  pageIndex: any;
  pageSize: number;
  textsysn: string;
  pageList: any;
  spinner: boolean;
  renderedData: any;
  pageSizeValue: any;
  search: any;
  filterSelectObj = [
   

  ]
  elements: any;
  filterActive: boolean = false;
  resourcePrivilege: any;
  builderList: any=[];
  text: string;
  checkBoxControl: any;
  selection: any;
  data: any;
  builderIdList: Object;
  firstFormGroup: FormGroup<any>;
  budgetEnabled: boolean=false;
  subLocationEnabled: boolean;
  budgetMinEnabled: boolean;

  constructor(
    private builderService: BuilderService,
    private router: Router,
    private snackBar: MatSnackBar,
    private commonService: CommonService,
    private dialogRef: MatDialogRef<SearchBuilderComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) data,
    private _formBuilder: UntypedFormBuilder,
    private clipboard: Clipboard,
    private formBuilder: FormBuilder

  ) {

    this.data = data.data;

    this.firstFormGroup = this.createWhatsappForm();
      this.url = this.router.url || '';
          this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; });
  }

  ngOnInit(): void {

  
    if(this.data['budget']!=undefined){

      if(this.data['budget']!=null){
        this.budgetEnabled=true;
        this.firstFormGroup.get("budget").setValue(this.data['budget']);
      }else{
        this.budgetEnabled=false;
      }
     
    
    }else{
      this.budgetEnabled=false;
    }

    if(this.data['budgetMin']!=undefined){

      if(this.data['budgetMin']!=null){
        this.budgetMinEnabled=true;
        this.firstFormGroup.get("budgetMin").setValue(this.data['budgetMin']);
      }else{
        this.budgetMinEnabled=false;
      }
     
    
    }else{
      this.budgetMinEnabled=false;
    }

    if(this.data['subLocation']!=undefined){

      if(this.data['subLocation']!=null){
        this.subLocationEnabled=true;
        this.firstFormGroup.get("subLocation").setValue(this.data['subLocation']);
      }else{
        this.subLocationEnabled=false;
      }
     
    
    }else{
      this.subLocationEnabled=false;
    }

    if(this.subLocationEnabled&&this.budgetEnabled){
      this.getAllBuilder();
    }else{
            this.firstFormGroup.markAllAsTouched();
   
        this.snackBar.open("Form is invalid. Please check all required fields.", '×', { 
          panelClass: 'error', 
          verticalPosition: 'bottom', 
          duration: 3000 
        });
    }
 
  }

  submit() {

  }


  private createWhatsappForm(): FormGroup {
    return this.formBuilder.group({
      budget: ['', Validators.required],
      subLocation:['', Validators.required],
      budgetMin:['', Validators.required]
    });
  }

  close() {
    this.dialogRef.close({ event: 'close' })
  }






  getAllBuilder() {
    this.filterActive = false;
    this.spinner = true;
    let object=this.getLocationData();

    this.builderService.BuilderSearchLocation(object,this.page, this.size, this.sortParam).subscribe(
      res => {
        this.spinner = false;
        this.builderList = new MatTableDataSource();
        this.builderList = res['content'];
        this.elements = res['numberOfElements'];
        this.builderList.sort = this.sort;
        this.builderList.paginator = this.paginator;
        this.pageList = res['totalElements'];
        this.pageSizeValue = getPageSize(this.pageList);
      },
      error => {
      }
    )
  }


  DetectingRequestType() {
    if (!this.filterActive) {
      this.getAllBuilder();
    }
    else {
      this.filterOption(this.search);
    }
  }


  getUpdate(event) {
    this.paginationDetail.next(event);
    this.page = event.pageIndex;
    this.size = event.pageSize;
    this.DetectingRequestType();
  }

 
 sortData(event) {
    if (event.active != 'actions') {
    this.page = Constant.PAGE;
    this.size = Constant.SIZE;
    this.sortParam = event.active;
    if (event.direction == 'asc') {
      this.sortParam = this.sortParam + "," + Constant.Asc;
    } else if (event.direction == 'desc') {
      this.sortParam = this.sortParam + "," + Constant.Dsc;
    }
    this.DetectingRequestType();
   }
  }

  @Input()
  columns: ListColumn[] = [
    { name: 'Location', property: 'location', visible: true, isModelProperty: true },
    { name: 'Builder', property: 'builder', visible: true, isModelProperty: true },
    { name: 'Action', property: 'actions', visible: true, disabled: true },
  ] as ListColumn[];

  onFilterChangeColumn(i) {

    if(this.subLocationEnabled&&this.budgetEnabled){
    if (i == undefined) {
      this.filterActive = false
      this.getAllBuilder();
    } else {
      this.page = Constant.PAGE;
      this.size = Constant.SIZE;
      this.filterOption(i)
    }
  }else{
          this.firstFormGroup.markAllAsTouched();
   
        this.snackBar.open("Form is invalid. Please check all required fields.", '×', { 
          panelClass: 'error', 
          verticalPosition: 'bottom', 
          duration: 3000 
        });
  }
  }

  onFilterChange(value) {
    if(this.subLocationEnabled&&this.budgetEnabled){
    if (value == '') {
      this.getAllBuilder();
    } else {
      this.page = Constant.PAGE;
      
     

  

      let searchTerm = "locationMain:" + '*' + value.trim() + '*'
      + "' OR builder:" + '*' + value.trim() + '*'
      + "' OR projectName:" + '*' + value.trim() + '*' + "' "

       
      this.filterOption(searchTerm)
    }
  }else{

          this.firstFormGroup.markAllAsTouched();
   
        this.snackBar.open("Form is invalid. Please check all required fields.", '×', { 
          panelClass: 'error', 
          verticalPosition: 'bottom', 
          duration: 3000 
        });
  }

  }


  filterOption(event) {
    this.filterActive = true;
    this.search = event;
    this.spinner = true;

    let object=this.getLocationData();

    object.search= this.search;
    this.builderService.BuilderSearchLocation(object, this.page, this.size, this.sortParam).subscribe(
      res => {
        this.spinner = false;
        this.builderList = res['content'];
        this.elements = res['numberOfElements'];
        this.pageList = res['totalElements'];
        this.pageSizeValue = getPageSize(this.pageList);
      },
      error => {
        this.spinner = false;
      })

  }
  getLocationData(){

    
    let budget= this.firstFormGroup.value.budget;

    let lowerBudget=budget*50/100;
  
    let difference=budget-lowerBudget;
  
    let higherBudget=Number(budget)+difference;

    let lowerBudgetMin=lowerBudget;
    let higherBudgetMIn=higherBudget;

    if(this.budgetMinEnabled){

      let budgetMin= this.firstFormGroup.value.budgetMin;

      lowerBudgetMin=budgetMin*50/100;
    
      let difference=budgetMin-lowerBudgetMin;
    
       higherBudgetMIn=Number(budgetMin)+difference;
  
      // let lowerBudgetMin=lowerBudget;
      // let higherBudgetMIn=higherBudget;


    }

  
  
    let object={
      "subLocation":this.firstFormGroup.value.subLocation,
      "minPrice":lowerBudget,
      "maxPrice":higherBudget,
      "search":null,
      "minPriceMin":lowerBudgetMin,
      "maxPriceMin":higherBudgetMIn,
    }

    return object;
     
  

  }

  addBuilder() {
    let builderId = 0;
    this.router.navigate([`builder/addbuilder/${builderId}`])
  }

  editBuilder(builderId) {
    this.router.navigate([`/builder/editbuilder/${builderId}`])
  }


  get visibleColumns() {
    return this.columns.filter(column => column.visible).map(column => column.property);

  }

  getAllBuilderById(builderId: any, type: any) {

    if (this.firstFormGroup.valid) {
    this.builderService.getBuilderId(builderId).subscribe(
      res => {
        this.builderIdList = res;

        if (this.builderIdList !== null) {
          if (type == 1) {
            this.copyFormat(this.builderIdList);
          } else if (type == 2) {
            this.sendMail(this.builderIdList);
          } else if (type == 3) {
            this.whatsapp(this.builderIdList);
          } else if (type == 4) {
            this.navigateLink(this.builderIdList);
          }

        }
      },
      error => {

      }
    );
    }
    else{
            this.firstFormGroup.markAllAsTouched();
   
        this.snackBar.open("Form is invalid. Please check all required fields.", '×', { 
          panelClass: 'error', 
          verticalPosition: 'bottom', 
          duration: 3000 
        });
    }
  }
  navigateLink(builderIdList: any) {
    let customField2 = builderIdList.customField2;
    if (customField2) {
        // this.router.navigate([`/${customField2}`]);
        window.open(customField2, '_blank');
    } else {
        console.error('customField2 is undefined or empty');
    }
}



  copyFormat(builderIdList: any) {

    let customField6 = builderIdList.customField8 || 'Team';

    const currentHour = new Date().getHours();
    let greeting;

    if (currentHour < 12) {
        greeting = "Good morning";
    } else if (currentHour < 18) {
        greeting = "Good afternoon";
    } else {
        greeting = "Good evening";
    }

    const leadInfo = `${greeting} team\nKindly register the below lead\n\nName: ${this.data.name}\nNumber: ${this.data.phoneNumber}\nMail id: ${this.data.email}\nBudget range: ${this.firstFormGroup.value.budget}\nProject: ${builderIdList.projectName}\n\nThank you ${customField6}`;
   // const leadInfo = `Name : ${this.data.name}\nNumber: ${this.data.phoneNumber}\nMail id : ${this.data.email}\nBudget range : ${this.firstFormGroup.value.budget}\nProject: ${builderIdList.projectName}\n\nThank you\n${customField6}`;

    this.clipboard.copy(leadInfo);

    this.snackBar.open('Copied to Clipboard!', 'X', {
      duration: 500,
      verticalPosition: 'bottom',
      panelClass: ['success'],
    });

    this.dialog.closeAll();
  }


  sendMail(builderIdList: any) {

    const emailInfo = {
      builerId: builderIdList.builderId,
      toMail: builderIdList.customField7,
      username: this.data.name,
      customerName: this.data.name,
      builderName: builderIdList.builder,
      customerMobile: this.data.phoneNumber,
      customerEmail: this.data.email,
      customerBudget:this.firstFormGroup.value.budget,
      thanks: builderIdList.customField8,
      subject: 'Builder Information',
      project:builderIdList.projectName
    };

    this.builderService.sendEmail(emailInfo).subscribe(
      (response) => {
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          this.dialog.closeAll();
        }
        else {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
          this.dialog.closeAll();
        }
      },
    );
  }

  navigateToWhatsApp(builderIdList) {

    let customField6 = builderIdList.customField8 || 'Team';

    const groupLink = builderIdList.customField2;

    const message = `Name : ${this.data.name}\nNumber: ${this.data.phoneNumber}\nMail id : ${this.data.email}\nBudget range : ${this.firstFormGroup.value.budget}\nProject: ${builderIdList.projectName}\n\nThank you\n${customField6}`;

    const whatsappUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(message)}&phone=&group=${encodeURIComponent(groupLink)}`;

    window.open(whatsappUrl, '_blank');

    this.dialog.closeAll();

  }


  whatsapp(builderIdList) {
    let customField6 = builderIdList.customField6 || 'Team';

    const groupLink = builderIdList.customField2;

    const currentHour = new Date().getHours();
    let greeting;

    if (currentHour < 12) {
        greeting = "Good morning";
    } else if (currentHour < 18) {
        greeting = "Good afternoon";
    } else {
        greeting = "Good evening";
    }

    const message = `${greeting} team\nKindly register the below lead\n\nName: ${this.data.name}\nNumber: ${this.data.phoneNumber}\nMail id: ${this.data.email}\nBudget range: ${this.firstFormGroup.value.budget}\nProject: ${builderIdList.projectName}\n\nThank you ${customField6}`;
    let encodedURL = encodeURIComponent(message);
    let url = `https://api.whatsapp.com/send?text=${encodedURL}&phone=&group=${encodeURIComponent(groupLink)}`;
  
    window.open(url, '_blank');

    this.dialog.closeAll();
}


  goToLink(url: any) {
		if (!url.includes('http://') && !url.includes('https://')) {
			this.router.navigate([url])
		} else {
			window.location.href = url;

		}
		
	  }



  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    protected _onDestroy = new Subject<void>();

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}

